<ng-container *ngIf="paramsUrl?.user_id && paramsUrl?.email && paramsUrl?.username; else empty">
  <div class="card bg-dark-lighter text-white">
    <div class="appbar mt-3">
      <button
        type="button"
        class="close icon-md back-button"
        data-bs-dismiss="modal"
        aria-label="Close"
        mat-icon-button
        (click)="onBack()"
        matTooltip="Back to previous page"
        matTooltipPosition="right"
      >
        <mat-icon style="font-size: 40px">arrow_back</mat-icon>
      </button>
      <h4>{{paramsUrl?.email}} &nbsp; ({{username}})</h4>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-lg-9">
          <table class="rox-table table-bordered bg-dark">
            <thead>
              <tr>
                <th class="text-center">MT5 Account</th>
                <th class="text-center">Account Type</th>
                <th class="text-center">Opening Date</th>
                <th class="text-center">MAMPAMM</th>
                <th class="text-center">Currency</th>
                <th class="text-center">Leverage</th>
                <th class="text-center">Balance</th>
                <th class="text-center">Credit</th>
                <th class="text-center">Parent IB ID</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of accountList; index as i">
                <td class="text-center">{{ item.login }}</td>
                <td class="text-center">{{ item.type }}</td>
                <td class="text-center">{{item.mt5_create_time | date: 'yyyy/MM/dd'}}</td>
                <td class="text-center">{{ item.is_mam === 0 ? 'No' : 'Yes' }}</td>
                <td class="text-center">{{ item.currency | uppercase }}</td>
                <td class="text-center">{{ item.leverage }}</td>
                <td class="text-center">
                  <span
                    labelNumber="{{ item.balance }}"
                    [currency]="item.currency"
                  ></span>
                </td>
                <td class="text-center">
                  <span
                    labelNumber="{{ item.credit }}"
                    [currency]="item.currency"
                  ></span>
                </td>
                <td class="text-center">
                  <div class="position-relative custom-tooltip-target">
                    {{item.ib_id}}
                    <div class="custom-tooltip" *ngIf="item.ib_id && item.parent_mail">
                      <h4 class="text-left">IB Information</h4>
                      <p class="text-nowrap">Email: {{item.parent_mail}}</p>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 col-lg-3">
          <div class="info-edit d-flex justify-content-between align-items-center">
            <b class="ms-2">User Information</b>
            <button
              *ngIf="enableEditProfile"
              (click)="isEditingAddressDialog = true; enableEditProfile = false"
              class="btn btn-primary btn-sm btn-edit btn-edit-custom me-2"
              mat-ripple
            >
              <i class="fa fa-edit small me-2"></i>
              Edit
            </button>

          </div>
          <address-info
            [childMode]="true"
            #addressInfo
            [addressInfo]="selectedAddress"
            [isEditting]="isEditingAddressDialog"
            [showError]="showAddressError"
          ></address-info>
          <div class="d-flex justify-content-end mt-2">
            <ng-container *ngIf="!enableEditProfile">
              <button mat-ripple class="btn btn-transparent rounded" (click)="onInfoDialogClose()">Cancel</button>
              <button (click)="saveEditAddressDialog()" mat-ripple class="btn btn-red rounded ms-3">Save</button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #empty>
  Something went wrong
</ng-template>
